import React from 'react';
import { useLocation } from 'react-router-dom';
import {
	CancellationData,
	withCancellationContext,
} from '../../../context/CancellationProvider';
import LargeCenterSpinner from '../../LargeCenterSpinner';
import TreeNode, {
	TreeData,
	TreeItemData,
} from '../../layouts/SidePanel/TreeNode';

interface Props {
	cancellationData: CancellationData;
}

const DraftCancellationSidebar = (props: Props) => {
	const { cancellationData } = props;

	const { policy, selectedCancellation } = cancellationData;

	if (!policy || !selectedCancellation) {
		return <LargeCenterSpinner />;
	}

	const { pathname } = useLocation();

	const routeName = pathname.split('/').pop();
	const cancellationLink = `/policy/${policy.locator}/cancellations/${selectedCancellation.locator}`;
	const overviewLink = `${cancellationLink}/details`;

	const getRootItem = () => {
		const children = ['Details'];

		return {
			id: 'root',
			children,
			hasChildren: true,
			isExpanded: true,
			isChildrenLoading: false,
			data: {
				title: 'root',
			},
		};
	};

	const getItems = () => {
		const isDetailsSelected =
			routeName === 'details' || routeName === 'auxData';

		return {
			root: getRootItem(),
			Details: {
				id: 'Details',
				children: [],
				hasChildren: false,
				isExpanded: true,
				isChildrenLoading: false,
				data: {
					title: 'Details',
					link: overviewLink,
					selected: isDetailsSelected,
				},
			},
		} as TreeItemData;
	};

	const items = getItems();

	const initializeTree = () => {
		const sidePanelData: TreeData = {
			rootId: 'root',
			items,
		};

		return sidePanelData;
	};

	const tree = initializeTree();

	return <TreeNode defaultExpanded={[]} treeData={tree} />;
};

export default withCancellationContext<Props>(DraftCancellationSidebar);
